import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ClientDetail from './pages/ClientDetail';
import Careers from './pages/Careers';
import HR from './pages/HR';
import SuperAdmin from './pages/SuperAdmin';
import Networking from './pages/Networking';
import Companies from './pages/Companies';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Login from './pages/Login';
import SignupSelection from './pages/SignupSelection';
import TechieSignup from './pages/TechieSignup';
import USATechieSignup from './pages/USATechieSignup';
import IndiaTechieSignup from './pages/IndiaTechieSignup';
import HiringManagerSignup from './pages/HiringManagerSignup';
import CompanySignup from './pages/CompanySignup';
import SchoolSignup from './pages/SchoolSignup';
import SignupSuccess from './pages/SignupSuccess';
import Verification from './pages/Verification';
import PostJob from './pages/companies/PostJob';
import TalentSearch from './pages/companies/TalentSearch';
import Advertise from './pages/companies/Advertise';
import Enterprise from './pages/companies/Enterprise';
import ContactSales from './pages/companies/ContactSales';
import Pricing from './pages/Pricing';
import Support from './pages/Support';
import Accessibility from './pages/Accessibility';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import theme from './styles/theme';
import ScrollToTop from './components/layout/ScrollToTop';
import './index.css';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import Cookies from './components/pages/Cookies';
import FinalizeSignIn from './pages/FinalizeSignIn';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          minHeight: '100vh', 
          width: '100%', 
          maxWidth: '100vw',
          overflowX: 'hidden',
          background: theme.palette.background.gradient,
        }}>
          <Navbar />
            <Box component="main" sx={{ 
              flexGrow: 1, 
              width: '100%',
              maxWidth: '100vw',
              overflowX: 'hidden'
            }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/client/:clientSlug" element={<ClientDetail />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/hr" element={<HR />} />
                <Route path="/admin" element={<SuperAdmin />} />
                <Route path="/networking" element={<Networking />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:id" element={<ServiceDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignupSelection />} />
                <Route path="/techie-signup" element={<TechieSignup />} />
                <Route path="/techie/ussignup" element={<USATechieSignup />} />
                <Route path="/techie/indiasignup" element={<IndiaTechieSignup />} />
                <Route path="/hiring-manager-signup" element={<HiringManagerSignup />} />
                <Route path="/company-signup" element={<CompanySignup />} />
                <Route path="/school-signup" element={<SchoolSignup />} />
                <Route path="/signup-success" element={<SignupSuccess />} />
                <Route path="/verification" element={<Verification />} />
                <Route path="/privacy" element={<Privacy />} />
                
                {/* Company Routes */}
                <Route path="/companies/post-job" element={<PostJob />} />
                <Route path="/companies/talent-search" element={<TalentSearch />} />
                <Route path="/companies/advertise" element={<Advertise />} />
                <Route path="/companies/enterprise" element={<Enterprise />} />
                <Route path="/companies/contact-sales" element={<ContactSales />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/support" element={<Support />} />
                <Route path="/accessibility" element={<Accessibility />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/finalize-signin" element={<FinalizeSignIn />} />
              </Routes>
            </Box>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
